import { getJSONObjectFromCookie as r, setCookieFromJSONObject as i } from "../../../shared/libraries/cookie-handling/index.js";
const c = () => ({
  RedirectToUrl: "",
  RedirectToCountryName: "",
  ShowPrompt: !1
}), s = (t, e) => {
  const o = r(t, c());
  o && typeof o == "object" && (o.RedirectToUrl = e, i(t, o));
}, C = (t, e) => {
  const o = r(
    t,
    c()
  );
  o && (o.RedirectToCountryName = e, i(t, o));
}, p = (t, e) => {
  const o = r(
    t,
    c()
  );
  o && typeof o == "object" && (o.ShowPrompt = e, i(t, o));
};
export {
  c as getDefaultCookie,
  C as setRedirectCountryInCookie,
  s as setRedirectUrlInCookie,
  p as setShowPromptInCookie
};
//# sourceMappingURL=index.js.map
